import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, pluck, tap } from 'rxjs/operators';

import { ModalConfirm, ModalReset, ModalShow } from '@shared/modal/modal.actions';

import { FormComponent } from '../form.component';
import * as FormActions from './form.actions';
import { FormState } from './form.reducer';

@Injectable()
export class FormEffects {
  openForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FormActions.formOpen),
      pluck('formState'),
      tap(({ data }: FormState) =>
        this.dialog.open(FormComponent, { panelClass: data.panelClass }),
      ),
      map(() => new ModalReset()),
    ),
  );

  closeForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FormActions.formClose),
      pluck('payload', 'forceClosing'),
      map((forceClosing: boolean) =>
        forceClosing
          ? new ModalConfirm()
          : new ModalShow({
              title: 'Are you sure you want to leave this page?',
              message: 'All unsaved changes will be lost.',
            }),
      ),
    ),
  );

  submitForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FormActions.formSubmit),
      map(({ redirectUrl }) => new ModalConfirm({ redirectUrl })),
    ),
  );

  constructor(private actions$: Actions, private dialog: MatDialog) {}
}
